<section class="store-guides" *ngIf="guides.length" aria-label="Getting started">
  <div class="guide" *ngFor="let guide of guides; trackBy: trackByPlatform">
    <h3 class="guide-title">
      <img *ngIf="guide.platformLogo" [src]="guide.platformLogo" alt="" class="guide-logo"/>
      <span>Getting started on {{ guide.platformName }}</span>
    </h3>
    <ol class="guide-steps">
      <li *ngFor="let step of guide.steps">{{ step }}</li>
    </ol>
  </div>
</section>
